import {
  LayoutHalfPageDefinition,
  LayoutListDefinition,
  LAYOUT_HALF_PAGE,
  LAYOUT_LIST,
  TEXT,
  LAYOUT_COLUMNS,
  LayoutColumnsDefinition,
  GAUGE,
  AudioDefinition,
  CARD
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';
import {
  KICKER_HINT,
  OPTIONAL_TEXT_FIELDS,
  editorCueValues,
  offersTemplateTextFields,
  optionalFieldsInEditor,
  optionalFieldValues
} from '../utils/optionalFields';
import { stepLabelOf } from '../items/gauge/stepLabel';

const getColorByIndex = (index: number) => {
  switch (index) {
    case 0:
      return '#F53258';
    case 1:
      return '#F78837';
    case 2:
      return '#F9BF60';
    case 3:
      return '#DBF337';
    case 4:
      return '#46E275';
    default:
      return '#' + Math.floor(Math.random() * 16777215).toString(16);
  }
};

export const getSteps = (
  items?: Array<{
    id: string;
    value: string;
    subvalue?: string;
    feedback: string;
    feedbackAudios?: AudioDefinition;
  }>
) => {
  const steps: Array<{
    id: string;
    color: string;
    value: string | number;
    label: string;
    feedback?: string;
    feedbackAudios?: AudioDefinition;
  }> = [];

  (items || []).forEach((item, index) => {
    steps.push({
      id: item.id,
      color: getColorByIndex(index),
      value: index + 1,
      label: stepLabelOf(item, index),
      feedback: item?.feedback,
      feedbackAudios: item?.feedbackAudios
    });
  });

  return steps;
};

export const Interactive13: Translator = sequence => {
  const optional = optionalFieldsInEditor(OPTIONAL_TEXT_FIELDS);
  const editsSteps = offersTemplateTextFields();
  const backgroundItems =
    sequence && sequence?.items
      ? sequence?.items.filter(item => item.type === 'BACKGROUND')
      : false;
  const background = backgroundItems ? backgroundItems[0] : false;

  const bgAny = background as Record<string, unknown>;
  const gaugeBackgroundSig =
    bgAny &&
    Array.isArray(bgAny.pictures) &&
    (bgAny.pictures as unknown[]).length
      ? (bgAny.pictures as Array<Record<string, unknown>>)
          .map(p => p.id)
          .join('-')
      : 'no_bg';
  return translate(sequence, item => {
    switch (item.__typename) {
      case 'Question': {
        const items = [
          {
            id: item.id,
            type: LAYOUT_LIST,
            values: { align: 'left' },
            items: [
              {
                type: TEXT,
                id: item.id + '_subtitle',
                items: [],
                values: {
                  ...optionalFieldValues(optional, 'subtitle', KICKER_HINT),
                  value: item.subtitle,
                  variant: 'sub_heading',
                  icon: 'question'
                }
              },
              {
                type: TEXT,
                id: item.id + '_title',
                items: [],
                values: {
                  ...optionalFieldValues(optional, 'title'),
                  value: item.title,
                  variant: 'heading1'
                }
              },
              {
                type: TEXT,
                id: item.id + '_body',
                items: [],
                values: {
                  ...optionalFieldValues(optional, 'body'),
                  value: item.body
                  // fontFamily: 'Raleway'
                }
              },
              {
                type: GAUGE,
                id: 'gauge_' + gaugeBackgroundSig,
                values: {
                  steps: getSteps(item.items as []),
                  shape: 'flat',
                  // The editor edits each step's label and feedback, for a
                  // company with the template text fields.
                  ...(editsSteps ? { editable: true } : {})
                },
                items: editsSteps
                  ? (item.items || []).map(field => ({
                      type: TEXT,
                      id: `${field.id}_feedback`,
                      items: [],
                      values: {
                        value: (field as { feedback?: string }).feedback || '',
                        ...editorCueValues('Add feedback')
                      }
                    }))
                  : []
              }
            ]
          } as LayoutListDefinition
        ];

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (background?.pictures && background?.pictures.length == 1) {
          return {
            id: item.id,
            type: LAYOUT_LIST,
            values: {
              align: 'center'
            },
            items: [
              {
                id: 'card_' + item.id,
                type: CARD,
                values: {
                  clearStyles: 'lg',
                  height: 'auto',
                  width: '500px'
                },
                items: items
              }
            ]
          };
        } else {
          return {
            id: item.id,
            type: LAYOUT_HALF_PAGE,
            values: {
              side: 'right'
            },
            items: [
              {
                type: LAYOUT_COLUMNS,
                id: '1',
                values: {},
                items: items
              } as LayoutColumnsDefinition
            ]
          } as LayoutHalfPageDefinition;
        }
      }
      default:
        return null;
    }
  });
};
